import React from 'react'
import style from './style'
import injectSheet from 'react-jss'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'
import images from './formFactorImages'
import ResolutionRange from './ResolutionRange'
import InfraredRange from './InfraredRange'
import AovRange from './AovRange'
import equals from 'ramda/src/equals'

const formFactorFns = {
  add: (f, formFactors) => ({ formFactors: [ ...formFactors, f ] }),
  remove: (f, formFactors) => ({ formFactors: formFactors.filter(ff => ff !== f) })
}

const FormFactor = ({ name, filterCameras, filters: { formFactors }, classes }) => {
  const selected = formFactors.includes(name)
  return (
    <div
      className={classes.formFactor + (selected ? ' selected' : '')}
      onClick={_ => filterCameras(formFactorFns[selected ? 'remove' : 'add'](name, formFactors), null, null)}
    >
      <img src={name === 'multi-imager' ? images["multi_imager"] : images[name]} />
      { name === 'multi-imager' ? 'Multi' : capitalizeFirstLetter(name) }
    </div>
  )
}

class Filter extends React.Component {
  state = {
    resolutionDisabled: true,
    irDisabled: true,
    aovRangeDisabled: true
  }

  filterAreChanged = filters => ({
    resolutionDisabled: filters.resolutions.highI === this.props.initialFilters.resolutions.highI &&
      filters.resolutions.lowI === this.props.initialFilters.resolutions.lowI,
    irDisabled: filters.ir.min === this.props.initialFilters.ir.min &&
      filters.ir.max === this.props.initialFilters.ir.max,
    aovRangeDisabled: equals(filters.aovRange, this.props.initialFilters.aovRange)
  })

  componentWillReceiveProps({ filters }) {
    this.setState(this.filterAreChanged(filters))
  }

  render() {
    const { props: { classes, formFactors, orderedResolutions, filterCameras, orderedInfrareds, aovRange },
      state: { resolutionDisabled, irDisabled, aovRangeDisabled } } = this
    return (
      <div className={classes.Filter}>
        <div className={classes.filterSection}>
          <ResolutionRange {...{ orderedResolutions, filterCameras, resolutionDisabled }} />
        </div>
        <div className={classes.formFactorSection}>
          <div>Form</div>
          <div className={classes.formFactors}>
            {
              formFactors.map((name, i) =>
                <FormFactor {...this.props} name={name} key={i} />
              )
            }
          </div>
        </div>
        <div className={classes.filterSection}>
          <InfraredRange {...{ filterCameras, orderedInfrareds, irDisabled }} />
        </div>
        <div className={classes.filterSection}>
          <AovRange {...{ filterCameras, aovRange, aovRangeDisabled }} />
        </div>
      </div>
    )
  }
}

export default injectSheet(style)(Filter)



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/Filter/index.js